import { milesToMeters } from '@shared/utils/milesToMeters';

export const centerAndZoom = (center: google.maps.LatLng | google.maps.LatLngLiteral, miles: number, map: google.maps.Map) => {
  // Fit map to a specific mile radius around a center point
  const circle = new google.maps.Circle({
    center,
    radius: milesToMeters(miles),
    fillOpacity: 0,
    fillColor: 'white',
    strokeWeight: 0,
    map
  });
  if (circle.getBounds()) {
    map.fitBounds(circle.getBounds()!);
    // Remove circle after map is set to proper bounds
    circle.setMap(null);
  }
};
